import { v4 as uuidv4 } from 'uuid';

export function MegaMenu(props = {}, childrenComponents = []) {
	return {
		componentName: 'MegaMenu',
		componentId: uuidv4(),
		props: Object.assign(
			{
				title: 'Departamento',
				orientation: '',
				defaultDepartmentActive: '',
				openOnly: '',
			},
			props,
		),
		childrenComponents,
	};
}
